import clsx from "clsx";
import React from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import analytics from "web/script/analytics/analytics";
import { StandardFilterProps } from "web/types/feed-filters";
import { CategoryFilterOption, InputFilterOption } from "web/types/universal-filters";
import styles from "./back-filter-item.module.css";

interface BackFilterItemProps extends StandardFilterProps {
    item: InputFilterOption | CategoryFilterOption;
    isSmallItem?: boolean;
    hasChildren?: boolean;
    ariaControls?: string;
    siblingOpen?: boolean;
    title: string;
}

function BackFilterItem({
    ariaControls,
    item,
    onClick,
    pendingFilterInfo,
    hasChildren,
    title,
}: BackFilterItemProps): JSX.Element {
    function handleClick(event: React.MouseEvent<HTMLAnchorElement>): void {
        event.preventDefault();
        analytics.event("filter_ux", "click", "more_button");
        onClick(item);
    }

    let checked = pendingFilterInfo.getChecked(item);

    return (
        <a
            href={item.url}
            className={styles.filterItem}
            onClick={handleClick}
            role="button"
            aria-expanded={hasChildren ? checked : undefined}
            aria-controls={hasChildren ? ariaControls : undefined}
        >
            {!checked ? (
                <SVGIcon
                    className={clsx(styles.icon, styles.iconChecked)}
                    name={"round-radiobutton-checked"}
                />
            ) : (
                <SVGIcon className={styles.icon} name={"round-radiobutton"} />
            )}
            <span className={styles.labelItem}>{title}</span>
        </a>
    );
}

export default BackFilterItem;
